export default {

  methods: {
    checkExceeding(tr, type = "value") {
      if (!tr.normative_value) return "Нет данных";
      if ((!tr.normative_value.pdv && !tr.normative_value.pdk) || !tr.value) {
        return "Нет данных";
      }
      let excess =
        tr.value / (tr.normative_value.pdv || tr.normative_value.pdk);
      if (type.toLowerCase() === "value") {
        return excess.toFixed(2) / 1;
      }
      return excess > 1;
    },


    checkExceedingObj(tr, type_state = "state") {
      // Проверки

      if (!tr.normative_value) return "Нет данных";
      let {pdv, pdk, ken, pds} = tr.normative_value;
      let {fon} = tr;

      if (!pdv && !pdk && !ken && !pds && !fon) {
        return "Нет данных";
      }
      if (!tr.value) return "Нет данных";
      // !Проверки

      let ret = {state: false, value: 0};

      if (pdv) {
        // если пдв есть то делю и вывожу во сколько раз превышение
        let ex = tr.value / pdv;
        ret = {
          state: ex > 1,
          value: parseFloat(ex.toFixed(2))
        };
      } else if (fon || pdk || ken || pds) {
        // если фон то сразу возвращаю фон
        if ((pdk || ken) === "fon") {
          ret = {state: true, text: "fon"};
        } else {
          let current_val = fon || pdk || ken || pds; // если есть
          //  достаю минимальное и максимальное значение
          current_val = current_val.trim();
          let [min_value, max_value] = current_val.split("-");
          // если максимального занчения нет то ставлю минимальное
          max_value = max_value || min_value;

          // привожу в строку заменяю из неё запятую на точку  чтобы привести значение в число
          min_value = parseFloat(`${min_value}`.replace(",", "."));
          max_value = parseFloat(`${max_value}`.replace(",", "."));
          tr.value = parseFloat(`${tr.value}`.replace(",", "."));

          //  простые проверки показаний
          if (tr.value > max_value) {
            ret = {
              state: true,
              text: "Превышенные показания",
              value: (tr.value / max_value || 0).toFixed(4)
            };
          } else if (tr.value < min_value) {
            ret = {
              state: true,
              text: "Заниженные показания",
              value: (min_value / tr.value || 0).toFixed(4)
            };
          } else {
            ret = {
              state: false,
              text: "Показания впределах нормы",
              value: 0
            };
          }
        }
      }
      return ret[type_state] === 'Infinity' ? 0 : ret[type_state];
      // tr.value / (tr.normative_value.pdv || tr.normative_value.pdk);
      // if (type.toLowerCase() === "value") {
      //   return excess.toFixed(2) / 1;
      // }
      // return excess > 1;
    },
    checkButtonPermission(value) {
      const hasPermission = (value, permissions) => {
        // Check if the current permission matches the value
        const permission = permissions.find(item => item.unique_name === value);

        if (permission) {
          return true;
        }

        // Check if the value has a submenu (nested permissions)
        if (value.submenu) {
          // Recursively check permissions in the submenu
          for (const childValue of value.submenu) {
            if (hasPermission(childValue, permissions)) {
              return true;
            }
          }
        }

        // Check if the permissions array has nested children
        for (const perm of permissions) {
          if (perm.children && hasPermission(value, perm.children)) {
            return true;
          }
        }

        // If no matching permission is found
        return false;
      }

      return hasPermission(value, this.$store.state.AppActiveUser.permissions_send);
    },

    hasPermission(val) {
      if (val === 'uzgidromet') {
        return 'true'
      } else {
        return 'false'
      }
      // console.log(val, 'val')
      // console.log(this.$store.state.AppActiveUser, 'this.$store.state.AppActiveUser')
      // this.$store.state.AppActiveUser.permissions.forEach((item) => {
      //   console.log(item, 'item')
      //   // if (val === item.unique_name) {
      //   //   return alert()
      //   // }
      // })
    },
  }
}
